import { Stack, Tile } from "@carbon/react";
import { CSSProperties, FC, ReactNode } from "react";

import {
  DashboardRowConfiguration,
  DashboardWidgetConfiguration,
} from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types.ts";
import { WidgetDefinition } from "src/dynamic-view-renderer/Widgets/Widget.typings.ts";
import WidgetHeader from "src/dynamic-view-renderer/Widgets/WidgetHeader.tsx";

export type WidgetContainerProps = {
  widgetConfig: DashboardWidgetConfiguration;
  rowConfiguration: DashboardRowConfiguration;
  widgetDefinition?: WidgetDefinition;
  children: ReactNode;
  header?: ReactNode;
  style?: CSSProperties;
  className?: string;
};
const WidgetContainer: FC<WidgetContainerProps> = ({
  widgetConfig,
  rowConfiguration,
  widgetDefinition,
  header,
  style,
  className,
  children,
}) => (
  <Tile
    className={className}
    style={{
      alignItems: "stretch",
      flexShrink: "1",
      flexGrow: widgetConfig.widthRatio ? (rowConfiguration.autoLayout ? "1" : "0") : "1",
      flexBasis: widgetConfig.widthRatio
        ? widgetConfig.widthRatio.includes("px")
          ? widgetConfig.widthRatio
          : `calc(${widgetConfig.widthRatio} - ${
              rowConfiguration.widgets.length - 1 > 0
                ? (rowConfiguration.widgets.length - 1) / rowConfiguration.widgets.length
                : 0
            }rem)` //minus the gap between widgets
        : "auto",
      minWidth: widgetConfig.widthRatio ? "min-content" : "unset",
      ...style,
    }}
  >
    <Stack gap={5}>
      {widgetDefinition &&
        (header ? (
          header
        ) : (
          <WidgetHeader title={widgetDefinition.title} description={widgetDefinition.description} />
        ))}
      <div
        className="overflow-hidden hover:overflow-auto"
        style={{
          height: rowConfiguration.height,
          scrollbarGutter: "stable",
        }}
      >
        {children}
      </div>
    </Stack>
  </Tile>
);

export default WidgetContainer;
